(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var overlay = qs('#fwCartOverlay');
  var drawer = qs('#fwCartDrawer');
  var closeBtn = qs('#fwCartClose');
  var itemsEl = qs('#fwCartItems');
  var subtotalEl = qs('#fwCartSubtotal');
  var countEl = qs('#fwCartCount');

  if (!overlay || !drawer || !itemsEl || !subtotalEl) return;

  var moneyFormat = window.fwMoneyFormat || "${{amount}}";

  function formatMoney(cents) {
    if (cents == null) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  async function refreshDrawer() {
    var cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var img = it.image ? it.image : '';
      var variant = it.variant_title ? it.variant_title : '';

      html += ''
        + '<div class="fw-cart-item" data-line="' + (i + 1) + '">'
        +   '<img class="fw-cart-item__img" src="' + img + '" alt="">'
        +   '<div>'
        +     '<div class="fw-cart-item__title">' + (it.product_title || '') + '</div>'
        +     (variant ? '<div class="fw-cart-item__variant">' + variant + '</div>' : '')
        +     '<div class="fw-cart-item__price">' + formatMoney(it.final_line_price) + '</div>'
        +   '</div>'
        +   '<div class="fw-cart-qty">'
        +     '<button type="button" data-qty="dec">-</button>'
        +     '<span>' + it.quantity + '</span>'
        +     '<button type="button" data-qty="inc">+</button>'
        +   '</div>'
        + '</div>';
    }

    itemsEl.innerHTML = html || '<div style="padding:10px 0;color:#666;">YOUR BAG IS EMPTY.</div>';
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (countEl) {
      countEl.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
    }

    // also update any theme bubble if present
    var bubble =
      qs('.cart-count-bubble span') ||
      qs('[data-cart-count]') ||
      qs('.header__icon--cart .count');

    if (bubble) bubble.textContent = String(cart.item_count);

    return cart;
  }

  async function changeLine(line, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    });
    await refreshDrawer();
  }

  drawer.addEventListener('click', async function (e) {
    var item = e.target.closest('.fw-cart-item');
    if (!item) return;

    var line = parseInt(item.getAttribute('data-line'), 10);
    if (!line) return;

    var btn = e.target.closest('button[data-qty]');
    if (!btn) return;

    var qtySpan = qs('.fw-cart-qty span', item);
    var currentQty = parseInt(qtySpan ? qtySpan.textContent : '1', 10) || 1;

    var nextQty = btn.getAttribute('data-qty') === 'inc'
      ? currentQty + 1
      : Math.max(0, currentQty - 1);

    await changeLine(line, nextQty);
  });

  // Open from header click
  document.addEventListener('click', async function (e) {
    var openBtn = e.target.closest('[data-fw-cart-open]');
    if (openBtn) {
      e.preventDefault();
      await refreshDrawer();
      openDrawer();
      return;
    }
  });

  // Optional: expose helpers for your PDP code if needed
  window.FWCart = {
    open: async function () { await refreshDrawer(); openDrawer(); },
    refresh: refreshDrawer,
    close: closeDrawer
  };

})();
